import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {
  GaTrackingEventName,
  GATrackingEventType,
} from '../../constants';

export class GATrackingCartLinkClickEvent implements GATrackingEvent {
  constructor(private payload: any) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.CartLinkClick;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.GoToCart,
      label: this.payload.label,
      gtmCustom: {
        category: this.payload.category,
      },
    };
  }
}
